<template>
  <v-footer white>
    <v-card flat tile class="light-green lighten-1 black--text text-center">
      <v-card-text>
        <v-btn v-for="icon in icons" :key="icon" class="mx-4 white--text" icon>
          <v-icon size="24px">
            {{ icon }}
          </v-icon>
        </v-btn>
      </v-card-text>

      <v-card-text class="white--text pt-0">
        <p>
          «Pasados cuatro años de aquel acuerdo histórico (el pacto del clima de
          París de 2015), se observa cómo los compromisos contraídos por los
          estados todavía son muy flojos y están lejos de alcanzar los objetivos
          previstos». (Papa Francisco)
        </p>
        <p>
        «Esta urgencia de los jóvenes, el mensaje que nos transmite es que no
        estamos haciendo lo suficiente, incluso cuando somos conscientes de lo
        que ocurre, no estamos reaccionando lo suficientemente rápido y tampoco
        estamos teniendo un compromiso suficiente con las respuestas. Así que
        tomo buena nota, escucho, creo que ningún responsable político puede
        hacer oídos sordos a esta exigencia de justicia intergeneracional».
        (Emmanuel Macron, presidente de Francia)</p>
        <p>El cambio comienza por nosotros, desde lo pequeño, que es tu hogar, tu vida, podemos hacer mucho</p>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-text class="white--text">
        {{ new Date().getFullYear() }} — <strong>Gestion de Residuos</strong>
      </v-card-text>
    </v-card>
  </v-footer>
</template>

<script>
export default {
  data: () => ({
    icons: ["mdi-facebook", "mdi-twitter", "mdi-linkedin", "mdi-instagram"],
  }),
};
</script>

<style>
</style>